import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const cookingVideoExample = defineVideoTemplate({
  slug: "cooking-video-example",
  title: "Cooking",
  description: "Recipe extraction",
  subdescription: "Watch a dish come together and turn it into a step-by-step recipe",
  poster: BASE_ASSETS.cookingVideoPoster,
  video: BASE_ASSETS.cookingVideo,
  prompt: "Give me the ingredients and step by step recipe.",
  enableThinking: true,
});
